import * as PIXI from 'pixi.js';

import { parseQuery } from './helpers/parseQuery';
import { partnerService } from '../services/helperService/PartnerService';
import { gameService } from '../services/GameService';
import { GAME_MODES, PLAYING_GAME_MODE, RtlLanguages } from './constats';
import { GAME_MODE, USER_DATA } from '../stateManagment/gameState';
import { isMobile as isMobileCore } from './isMobile';

export const init = () => {
  const query = parseQuery(window.location.search);
  const { playerexternalid, partnerid, lan, language, culture, opentype, mode, currencysymbol } = query;
  if (query.hasOwnProperty('partnerid')) {
    partnerService.partnerId = partnerid;
  }

  partnerService.currencySymbol = currencysymbol

  if (query.hasOwnProperty('culture') || query.hasOwnProperty('language') || query.hasOwnProperty('lan')) {
    partnerService.language = culture || lan || language;
  }

  if (playerexternalid) {
    USER_DATA.next({ id: playerexternalid });
  }
  gameService.mode = playerexternalid ? PLAYING_GAME_MODE.REAL : PLAYING_GAME_MODE.DEMO;

  if (
    (query.hasOwnProperty('opentype') && opentype === 'fun')
    ||
    (query.hasOwnProperty('mode') && mode === 'fun')
  ) {
    gameService.mode = PLAYING_GAME_MODE.DEMO;
  }

  if (PIXI.utils.isMobile.phone || PIXI.utils.isMobile.tablet || isMobileCore()) {
    document.documentElement.classList.add('is-mobile');
    GAME_MODE.next(GAME_MODES.MOBILE);
  } else {
    document.documentElement.classList.add('is-web');
    GAME_MODE.next(GAME_MODES.DESKTOP);
  }

  if (RtlLanguages.includes(partnerService.language)) {
    document.documentElement.setAttribute('data-dir', 'rtl');
  }

};
